import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid, GridItem, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import ApproveProposalButton from '~/client-flow/components/ApproveProposalButton';
import { StepPage } from '~/client-flow/components/StepPage';
import { TextBox } from '~/client-flow/components/TextBox';
import BankSecurityRow from '~/components/BankSecurityRow/BankSecurityRow';
import ManagePaymentMethods from '~/components/ManagePaymentMethods/ManagePaymentMethods';
import { ErrorText } from '~/constants';
import { useStore } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { relationshipModel } from '~/models';
import { selectors } from '~/store/state-selectors';
import { useResponsive } from '../../contexts';
import { COBStep, getStepName, isApproveProposalDisabled, stepsTextsPath } from '../ClientOnboarding.utils';
import { useCobConfig } from '../CobConfigContext';
export const { ConnectPaymentMethodStepTestIds } = getTestIds();
export default function ConnectPaymentMethodStep(props) {
    const { isMemberClient = false, selectedPaymentId, disabledReason, approveAgreementStatus = null, previewStatus, onSelectPaymentMethod, onDone, onBack } = props;
    const { relationship } = useCobConfig();
    const isVendor = useStore(selectors.user.isVendor);
    const userId = useStore(selectors.user.id);
    const isPreview = !!previewStatus;
    const { t: texts } = useLocaleKeys('clientFlow.connectPaymentMethod');
    const { t: stepsTexts } = useLocaleKeys(stepsTextsPath);
    const { isMobile, isDesktop } = useResponsive();
    const role = useStore(selectors.user.role);
    const disabled = isApproveProposalDisabled(disabledReason, isPreview, relationship, userId, role);
    return /*#__PURE__*/ _jsx(StepPage, {
        header: getStepName(COBStep.paymentMethod, relationship, stepsTexts),
        disabledReason: disabled ? disabledReason : undefined,
        errorMessage: approveAgreementStatus === 'error' ? ErrorText.UnexpectedErrorTryAgain : '',
        testId: ConnectPaymentMethodStepTestIds.Root(),
        primaryBtn: /*#__PURE__*/ _jsx(ApproveProposalButton, {
            onDone: onDone,
            disabled: disabled || approveAgreementStatus === 'loading',
            testId: relationship.isSample || isPreview ? ConnectPaymentMethodStepTestIds.TestAgreementSubmitButton() : ConnectPaymentMethodStepTestIds.SubmitButton(),
            relationship: relationship,
            isDesktop: isDesktop,
            previewStatus: previewStatus
        }),
        onBackBtnClick: onBack,
        children: /*#__PURE__*/ _jsxs(Grid, {
            children: [
                /*#__PURE__*/ _jsx(GridItem, {
                    children: /*#__PURE__*/ _jsx(TextBox, {
                        children: /*#__PURE__*/ _jsx(Typography, {
                            children: texts.selectPaymentMethod()
                        })
                    })
                }),
                /*#__PURE__*/ _jsx(GridItem, {
                    span: 12,
                    children: /*#__PURE__*/ _jsx(ManagePaymentMethods, {
                        isProposal: true,
                        vendorId: relationshipModel.vendor(relationship),
                        customerId: relationshipModel.customer(relationship),
                        showCreditCardFee: !relationshipModel.actualIsVendorCoveringCCFee(relationship),
                        isVendorCoveringFees: relationshipModel.actualIsVendorCoveringCCFee(relationship),
                        isPreview: isPreview,
                        isSample: relationshipModel.isSample(relationship),
                        isMemberClient: isMemberClient,
                        isInviteMemberDisabled: isVendor || relationshipModel.isSample(relationship) || isPreview,
                        onSelectPaymentMethod: (pm)=>{
                            onSelectPaymentMethod(pm ? {
                                id: pm.id,
                                type: pm.type,
                                last4: pm.last4,
                                fundingSourceId: pm.id
                            } : undefined);
                        },
                        relationshipId: relationshipModel.id(relationship),
                        initialSelectedPaymentMethodId: selectedPaymentId
                    })
                }),
                /*#__PURE__*/ _jsx(GridItem, {
                    span: 12,
                    children: /*#__PURE__*/ _jsx(BankSecurityRow, {
                        mobileView: isMobile
                    })
                })
            ]
        })
    });
}
